// src/admin/pages/BannerAnalyticsPage.jsx
import PageHeader from "../components/PageHeader";
import AnalyticsOverviewCards from "../components/AnalyticsOverviewCards";
import AnalyticsLineChart from "../components/AnalyticsLineChart";
import AnalyticsBarChart from "../components/AnalyticsBarChart";
import AnalyticsTable from "../components/AnalyticsTable";
import useBannerAnalytics from "../hooks/useBannerAnalytics";

export default function BannerAnalyticsPage() {
    const {
        dashboard,
        performance,
        timeline,
        loading,
        error,
    } = useBannerAnalytics();

    console.log(performance);

    if (loading) {
        return (
            <div className="py-20 text-center">
                Loading analytics...
            </div>
        );
    }
    if (error) {
        return (
            <div className="py-20 text-center">
                Failed to load analytics.
            </div>
        );
    }

    return (
        <div className="space-y-8">
            <PageHeader
                title="Banner Analytics"
                subtitle="Advertisement Performance"
            />

            <AnalyticsOverviewCards
                cards={[
                    {
                        title: "Total Banners",
                        value: dashboard.total_banners,
                    },
                    {
                        title: "Impressions",
                        value: dashboard.total_impressions,
                    },
                    {
                        title: "Clicks",
                        value: dashboard.total_clicks,
                    },
                    {
                        title: "CTR",
                        value: `${dashboard.overall_ctr}%`,
                    },
                    {
                        title: "Active",
                        value: dashboard.active_banners,
                    },
                    {
                        title: "Inactive",
                        value: dashboard.inactive_banners,
                    },
                ]}
            />

            <AnalyticsLineChart
                title="Daily Banner Activity"
                description="Impressions and clicks over time"
                data={timeline}
                xKey="date"  // Add this - the key for X-axis data
                lines={[     // Add this - define what lines to show
                    {
                        dataKey: "impressions",
                        name: "Impressions",
                        color: "#8884d8",
                    },
                    {
                        dataKey: "clicks",
                        name: "Clicks",
                        color: "#82ca9d",
                    },
                ]}
            />

            <AnalyticsBarChart
                title="Banner CTR by Banner"
                description="Click-through rate for each banner"
                data={performance}
                xKey="title"
                bars={[
                    {
                        dataKey: "ctr",
                        name: "CTR (%)",
                        color: "#8884d8",
                    },
                ]}
            />

            <AnalyticsTable
                title="Banner Performance"
                data={performance}
            />
        </div>
    );
}